export enum FieldNames {
    Emails = 'emails',
    Email = 'email',
    AssignedLearningPath = 'assignedLearningPath',
    EnterpriseIds = 'enterpriseIds',
    RoleIds = 'roleIds',
    Privileges = 'privileges',
    ReceiveCustomerMessages = 'receiveCustomerMessages',
    RolesAndPermissions = 'rolesAndPermissions',
    FirstName = 'firstName',
    LastName = 'lastName',
    Status = 'status',
    SuperiorProfileId = 'superiorProfileId',
    DepartmentId = 'departmentId',
    Cashiers = 'cashiers',
    Reset2FA = 'reset2FA',
    EmployeeIncentiveCode = 'employeeIncentiveCode',
}
